
import React from 'react';
import { TextField, Grid, Typography, IconButton, Button, Container } from '@material-ui/core';
import FileBase from 'react-file-base64';
import { Link, useHistory, useLocation } from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ArrowForwardSharpIcon from '@material-ui/icons/ArrowForwardSharp';
import ArrowBackSharpIcon from '@material-ui/icons/ArrowBackSharp';
import useStyles from './styles';
import Input from '../../Input/Input';
import useCommonStyles from '../../../CommonStyle/commonStyle';
import useCommonAuthStyles from '../../commonAuthStyle';
import defaultProfilePic from '../../../../assets/icons/defaultProfilePic.jpg';
import uploadIcon from '../../../../assets/icons/upload_icon.svg';
interface signupProp {
    form: { firstName: string, lastName: string, spellFirstName: string, spellLastName: string, email: string, userID: string, profilePic: string, password: string, confirmPassword: string, userType: string, companyName: string },
    handleSubmit: ((e: React.FormEvent<HTMLFormElement>) => void),
    handleImage: ((image: any) => void),
    switchMode: (() => void),
    setSignupStep: ((value: number) => void),
    setNext: ((value: boolean) => void),
}

const IconSetup = ({ form, handleSubmit, handleImage, switchMode, setSignupStep, setNext }: signupProp) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const commonAuthClasses = useCommonAuthStyles();

    const fileChangedHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        //@ts-ignore
        console.log(e.target.files[0]);
    }

    const hiddenFileInput = React.useRef(null);

    const handleClick = (e: any) => {
        //@ts-ignore
        hiddenFileInput.current.click();
    };

    return (
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3} className={commonAuthClasses.parentGridContainer}>
            <Grid item xs={9} sm={6} md={6} className={commonAuthClasses.leftGrid}>
                <Typography className={commonAuthClasses.motivationalTitle} >
                    プロフィールアイコンを作ろう
                </Typography>
                <Typography className={commonAuthClasses.subTitle}>
                    プロフィール画像をアップロードしましょう
                </Typography >
                <Typography component={'span'} variant="body1" className={classes.upTo2M}>
                    <br /> （２MBまで）
                </Typography >
            </Grid>
            <Grid container item xs={12} sm={6} md={6}>

                <form name="profileImageForm" className={classes.form} onSubmit={handleSubmit}>
                    {Boolean(form.profilePic) ?
                        <Container className={classes.imageParentDiv}>
                            <img src={form.profilePic} className={classes.profileImage} />



                            <Button onClick={handleClick} className={classes.imageEdit}>
                                <div>
                                    <img src={uploadIcon} className={classes.uploadIcon} />
                                    <br />
                                    <Typography className={classes.uploadText} > 画像を変更 </Typography>
                                </div>
                            </Button>
                            <input name="upload" type="file"
                                ref={hiddenFileInput}
                                onChange={handleImage}
                                style={{ display: 'none' }} />

                            <Button name="delete" onClick={handleImage} className={classes.deleteButton}>
                                削除
                            </Button>
                        </Container> :
                        <Container className={classes.imageParentDiv}>
                            <img src={defaultProfilePic} className={classes.profileImage} />
                            <Button name="upload" onClick={handleClick} className={classes.imageEdit}>
                                <div>
                                    <img src={uploadIcon} className={classes.uploadIcon} />
                                    <br />
                                    <Typography className={classes.uploadText} >画像をアップロード</Typography>
                                </div>
                            </Button>
                            <input name="upload" type="file"
                                ref={hiddenFileInput}
                                onChange={handleImage}
                                style={{ display: 'none' }} />
                        </Container>
                    }


                    {/* ////////////// */}
                    <Grid container justifyContent="space-between">
                        <Button type="submit" variant="contained" color="primary" className={commonAuthClasses.submit} onClick={() => setSignupStep(0)}>
                            <ArrowBackSharpIcon color="inherit" />                            </Button>
                        <Button type="submit" variant="contained" color="primary" className={commonAuthClasses.submit} onClick={() => setNext(true)}>
                            <ArrowForwardSharpIcon color="inherit" />
                        </Button>
                    </Grid>

                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link to="/startup/signup" className={commonAuthClasses.hintLinkBtn}>アカウントをお持ちの方はこちら</Link>
                        </Grid>
                    </Grid>

                </form>
            </Grid>

        </Grid>
    )
};

export default IconSetup;



